import { createContext, useContext } from "react";
import PropTypes from "prop-types";

const LocaleProviderContext = createContext();
LocaleProviderContext.displayName = "localProvider";

export const useLocaleProvider = () => useContext(LocaleProviderContext);

export const useTranslate = (languageStrings) => (string) =>
  languageStrings[string];

export const LocaleProvider = ({ children, languageStrings }) => {
  return (
    <LocaleProviderContext.Provider value={languageStrings}>
      {children}
    </LocaleProviderContext.Provider>
  );
};

LocaleProvider.propTypes = {
  children: PropTypes.node.isRequired,
  languageStrings: PropTypes.object,
};
